<!-- A simple compact button allowing user to click to copy something to the clipboard -->
<template>
    <appends-button v-if="supportsClipboardApi" icon="content_copy" @click.stop="copy">
        <q-tooltip>{{ whatCopied || (label ?? $t('copy_to_clipboard')) }}</q-tooltip>
    </appends-button>
</template>

<script setup>
import AppendsButton from './AppendsButton.vue'
import { timeout } from 'src/utils/misc.js'
import { ref } from 'vue'

const props = defineProps({
    copyFn: Function, // Callback that needs to produce a string to copy to the clipboard
    label: String,
})

const supportsClipboardApi = !!window.navigator.clipboard
const whatCopied = ref()

async function copy() {
    navigator.clipboard.writeText(await props.copyFn())
    whatCopied.value = trans('link_copied')

    timeout(() => whatCopied.value = null, 2000)
}
</script>
